module.exports = __webpack_public_path__ + "static/media/carousel15.73237ec1.jpg";